<template>
    <div>
        <template v-if="crud_loan_tiers === true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Loan Tier </h1>
            </div>
            <div class="global-main">
                <form id="cityForm" @submit.prevent="addLoanTier">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Charges </label>
                            <input v-model="form.charges" type="text" name="charges" class="form-control" :class="{ 'is-invalid': form.errors.has('charges') }">
                            <has-error :form="form" field="charges"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Type </label>
                            <select v-model="form.loan_type" name="loan_type" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('loan_type') }">
                                <option value="COMPANY">Company</option>
                                <option value="INVOICE_DISCOUNTING">Invoice Discounting</option>
                            </select>
                            <has-error :form="form" field="loan_type"></has-error>
                        </div>
                        <div class="form-group">
                            <label> FED Deduction </label>
                            <select v-model="form.fed" name="fed" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('fed') }">
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                            </select>
                            <has-error :form="form" field="fed"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Installment Tenure </label>
                            <input v-model="form.installment_tenure" type="text" name="installment_tenure" class="form-control" :class="{ 'is-invalid': form.errors.has('installment_tenure') }">
                            <has-error :form="form" field="installment_tenure"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Bullet Payment Tenure </label>
                            <input v-model="form.bullet_payment_tenure" type="text" name="bullet_payment_tenure" class="form-control" :class="{ 'is-invalid': form.errors.has('bullet_payment_tenure') }">
                            <has-error :form="form" field="bullet_payment_tenure"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/loanTiers" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_loan_tiers === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_loan_tiers === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                    charges : '',
                    loan_type : '',
                    fed : '',
                    installment_tenure : '',
                    bullet_payment_tenure : ''
                }),
                crud_loan_tiers : null,
            }
        },
        methods: {
            addLoanTier() {
                this.$Progress.start();
                this.form.post('api/addLoanTier')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Loan Tier created successfully');
                        this.$router.push('/loanTiers');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_loan_tiers').then(result => {
                this.crud_loan_tiers = result.crud_loan_tiers;
            }).then(result => {
                if(this.crud_loan_tiers == true){
                    this.$Progress.finish();
                }
            });
            // axios.get('/api/addLoanTier')
            // .then((response)=> {
            //     this.pageView = response.data.pageView;
            // }).then((response) => {
            //     $('.selectpicker').selectpicker('referesh');
            // })
            // .catch((err)=> {
            //     this.showAlertBox('error','Problem in network call, please try again');
            // });
        },
    }
</script>
